import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { NotificationsLevel } from "../../../lib/enums";
import { ErrorResponse } from "../../../requests/@types";
import { route } from "../../../shim/jsbridge";
import { show } from "../../../notifications/notifications";
import api from "../api";
import { HTTP_TOO_MANY_REQUEST_STATUS_CODE } from "../consts";
import { sampleReportKeys } from "../queryKeys";

/**
 * Downloads memstrings in 7z format
 * @param hash samples hash value
 * @param analysisId analysisId for specific analysis
 * @param isNetwork fetch from network report
 * @return { downloadMemstrings }
 */
const useDownloadMemstrings = (
  hash: string,
  analysisId: string,
  isNetwork = false
) => {
  const downloadUrl = route(
    "api_rl_dynamic_analysis_resource_memstrings",
    [hash, analysisId],
    isNetwork ? { isNetwork } : {}
  );

  const { mutate } = useMutation<AxiosResponse<void>, ErrorResponse>({
    mutationKey: sampleReportKeys.downloadMemstrings(
      hash,
      analysisId,
      isNetwork
    ),
    mutationFn: () =>
      api.downloadRlSandboxReportMemstrings(hash, analysisId, isNetwork),
    onSuccess: () => {
      window.location = downloadUrl;
    },
    onError: error => {
      const errorMessage =
        error.status === HTTP_TOO_MANY_REQUEST_STATUS_CODE
          ? "Exceeding disk or memory usage, check system health status for more information."
          : "Unexpected error occurred while downloading MemStrings.";

      show({
        level: NotificationsLevel.ERROR,
        message: errorMessage
      });
    }
  });

  const downloadMemstrings = () => {
    show({
      level: NotificationsLevel.SUCCESS,
      message: "Memstring download has started..."
    });
    mutate();
  };

  return { downloadMemstrings };
};

export default useDownloadMemstrings;
